<template>
  <div class="metadata-modal">
    <div class="body" ref="body">
      <type-field 
        class="grid-row-1-2"
        :root="rootNode" 
        :type="formData.type" 
        :limitCompType="limitCompType"
      ></type-field>
      <div class="radio-group grid-col-1-4 grid-row-2-3">
        <label> 
          Default Proxy Indicator
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.DEFAULT_CHAIRMAN"></tooltip>
        </label>
        <div class="radio-block">
          <input
            type="radio"
            v-model="formData.defaultChairmanAsIndVal"
            name="defaultChairmanAsIndVal"
            id="defaultChairman-1"
            value="1"
            required
            checked
          />
          <label for="defaultChairman-1">Chairman of the Meeting</label>
        </div>
        <div class="radio-block">
          <input
            type="radio"
            v-model="formData.defaultChairmanAsIndVal"
            name="defaultChairmanAsIndVal"
            id="defaultChairman-2"
            value="2"
            required
            checked
          />
          <label for="defaultChairman-2">Non-chairman proxyholder(s)</label>
        </div>
        <div class="radio-block">
          <input
            type="radio"
            v-model="formData.defaultChairmanAsIndVal"
            name="defaultChairmanAsIndVal"
            id="defaultChairman-3"
            value="3"
            required
            checked
          />
          <label for="defaultChairman-3">Non-chairman proxyholder(s), but will fallback to chairman if proxy does not attend</label>
        </div>
      </div>
      <div class="checkbox-block grid-row-3-4">
        <input
          type="checkbox"
          name="hideProportionHeader"
          id="metadata-checkbox-1"
          v-model="formData.hideProportionHeader"
          class="checkbox-input"
        />
        <label for="metadata-checkbox-1">
          Hide Proportion Header
          <tooltip :text="TOOLTIP_TEXT.HIDE_PROPORTION_HEADER"></tooltip>
        </label>
      </div>
      <div class="checkbox-block grid-row-3-4">
        <input
          type="checkbox"
          name="hideInlineLabels"
          id="metadata-checkbox-2"
          v-model="formData.hideInlineLabels"
          class="checkbox-input"
        />
        <label for="metadata-checkbox-2">
          Hide Inline Labels
          <tooltip :text="TOOLTIP_TEXT.HIDE_INLINE_LABEL"></tooltip>
        </label>
      </div>
      <div class="grid-col-1-4 grid-row-4-5">
        <slot></slot>
      </div>
      <fieldset v-if="!simpleView" class="more-option grid-col-1-4 grid-row-5-6">
        <legend>More Options</legend>
      </fieldset>
    </div>
  </div>
</template>

<script>
import { ROOT_NODE, TOOLTIP_TEXT } from "../mixins/constant-mixin";
import TypeField from "./TypeField.vue";
import Tooltip from "./Tooltip.vue";
import { Bus } from "../main";

export default {
  name: "PFRPModal",
  props: {
    metadata: {
      type: Object,
      required: true,
    },
    state: {
      type: Object,
    },
    simpleView: {
      type: Boolean,
    },
    limitCompType: {
      type: String,
    },
  },
  data() {
    return {
      formData: structuredClone(this.metadata),
      rootNode: ROOT_NODE.AREAS,
      TOOLTIP_TEXT: TOOLTIP_TEXT
    };
  },
  watch: {
    metadata: function () {
      this.formData = structuredClone(this.metadata);
    },
    state: function () {
      if (this.state.closing) {
        if (this.state.saving) {
          this.$emit("metadataSaved", this.formData);
        } else {
          this.formData = structuredClone(this.metadata);
        }
      }
    },
    simpleView: function () {
      this.insertIntoComponentModal();
    },
  },
  components: {
    "type-field": TypeField,
    "tooltip": Tooltip,
  },
  mounted() {
    this.insertIntoComponentModal();
  },
  methods: {
    getCompType: function (type) {
      return type.toLowerCase() === this.formData.type.toLowerCase();
    },
    insertIntoComponentModal: function () {
      const gridRow = "3 / 4";
      Bus.$emit("insertIntoComponentModal", this.$refs.body, gridRow);
    },
  },
};
</script>

<style scoped>
.metadata-modal {
  width: 100%;
}

.body {
  padding: 1rem 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 1rem;
}

.body > div,
.body > form {
  padding: 0 2rem;
}

.input-block {
  display: flex;
  flex-direction: column;
}

.input-block input,
.input-block select {
  padding: 8px;
  margin-top: 4px;
}

/* Hide arrow in number input */
/* Chrome and safari */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.radio-group > * {
  margin: 0.2rem 0;
}

.radio-block,
.checkbox-block {
  align-self: center;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  margin-right: 30px;
}

.checkbox-input {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}

.grid-col-1-4 {
  grid-column: 1 / 4;
}

.grid-row-1-2 {
  grid-row: 1 / 2;
}

.grid-row-2-3 {
  grid-row: 2 / 3;
}

.grid-row-3-4 {
  grid-row: 3 / 4;
}

.grid-row-4-5 {
  grid-row: 4 / 5;
}

.grid-row-5-6 {
  grid-row: 5 / 6;
}

.more-option {
  margin: 0;
  padding: 0;
  border: none;
  border-top: 1px solid #808080;
  text-align: center;
}

.more-option > legend {
  padding: 0 0.5rem;
}

.required {
  color: #f00;
}
</style>